export default "__VITE_ASSET__Di5CyBuU__"